import { render } from "./SendVerifyCode.vue?vue&type=template&id=3049dfc9&scoped=true&ts=true"
import script from "./SendVerifyCode.vue?vue&type=script&lang=ts"
export * from "./SendVerifyCode.vue?vue&type=script&lang=ts"

import "./SendVerifyCode.vue?vue&type=style&index=0&id=3049dfc9&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3049dfc9"]])

export default __exports__